




import Vue from "vue";
import { Component, Prop, Provide, Watch } from "vue-property-decorator";
import * as L from "leaflet";
import * as esri from "esri-leaflet";
import "leaflet.markercluster";
import MapConfig from "../mapConfig.model";
import { CobMarker } from "../types";

@Component({})
export default class MapMarker extends Vue {
  clusterGroup: any | null = null;
  @Prop() mapConfig!: MapConfig;
  @Prop() markers!: CobMarker[];
  @Prop() map!: L.Map;
  @Prop() marker!: CobMarker;  
  markerGroup: L.Marker[] = [];

  mounted() {
  }
  @Watch('markers', {immediate: true})
  showMarkers(){
    
    var vm = this;
    let icons: any = {
      red: L.icon({
        iconUrl:
          "https://static.cityofboise.net/scripts/js-libs/esri-leaflet-map/1.0.0/assets/img/map-marker--red.svg"
      }),
      green: L.icon({
        iconUrl:
          "https://static.cityofboise.net/scripts/js-libs/esri-leaflet-map/1.0.0/assets/img/map-marker--green.svg"
      }),
      orange: L.icon({
        iconUrl:
          "https://static.cityofboise.net/scripts/js-libs/esri-leaflet-map/1.0.0/assets/img/map-marker--orange.svg"
      }),
      white: L.icon({
        iconUrl:
          "https://static.cityofboise.net/scripts/js-libs/esri-leaflet-map/1.0.0/assets/img/map-marker--white.svg"
      }),  
      blue: L.icon({
        iconUrl:
          "https://static.cityofboise.net/scripts/js-libs/esri-leaflet-map/1.0.0/assets/img/map-marker--blue.svg"
      }),   
      default: L.icon({
        iconUrl:
          "https://static.cityofboise.net/scripts/js-libs/esri-leaflet-map/1.0.0/assets/img/map-marker--yellow.svg"
      }),
    };
   
    vm.clusterGroup = L.markerClusterGroup({
      showCoverageOnHover: false
    });
    vm.markers.forEach(markerData => {
      let marker: any = null;
      if (
        markerData &&
        markerData.point &&
        markerData.point.latitude &&
        markerData.point.longitude &&
        markerData.point.latitude != null &&
        markerData.point.longitude != null
      ) {
        var markerIcon = markerData.icon && icons[markerData.icon]  ? icons[markerData.icon] : icons.default;
        if(markerData.iconUrl){markerIcon = L.icon({iconUrl: markerData.iconUrl});}
        marker = new L.Marker(
          new L.LatLng(markerData.point.latitude, markerData.point.longitude),
          { icon: markerIcon, title: (markerData.id) ? markerData.id : ''}
        );       
        
        if(markerData.popup && markerData.popup.title && markerData.popup.text){
          marker.bindPopup(function(layer:any) {
          return L.Util.template("<h3>{NAME}</h3><p>{TEXT}</p>", {
            NAME: markerData.popup.title ? markerData.popup.title : "",
            TEXT: markerData.popup.text ? markerData.popup.text : ""
          });
        });
        }
        vm.markerGroup.push(marker);
        vm.clusterGroup.addLayer(marker);
      } else {
       // eslint-disable-next-line
        console.log(
          "Missing marker information.  Requires a point.latitude and a point.longitude  Data:" +
            markerData.point 
        );
      }
    });
    this.map.addLayer(vm.clusterGroup);
    if (
      this.mapConfig.fitToMarkers &&
      vm.markers.length > 0 &&
      vm.markerGroup.length > 0 &&
      vm.clusterGroup
    ) {
      this.map.fitBounds(vm.clusterGroup.getBounds(), {
        paddingTopLeft: [10, 10]
      });
    }
    vm.clusterGroup.refreshClusters();
  }
 @Watch('marker', {immediate: true})
 showMapMarker(){
   var vm = this;
   if(vm.marker && vm.marker.point && vm.marker.point.longitude && vm.marker.point.latitude){
   
    vm.map.setView(new L.LatLng(vm.marker.point.latitude,vm.marker.point.longitude),18);
    for (var i in vm.markerGroup){
            var markerTitle = vm.markerGroup[i].options.title;

            if (markerTitle == vm.marker.id){
                vm.markerGroup[i].openPopup();
            }
        }
    }
 }
  

  
  beforeDestroy() {
    var vm = this;
    if (this.clusterGroup) {
      this.map.removeLayer(this.clusterGroup);
    }
  }
}
